module.exports = __webpack_public_path__ + "img/3.ea0c9790.svg";